import ConfirmationDialog from '../../ConfirmationModals/ConfirmationDialog.jsx';
import { useTranslation } from '../../../context/TranslationContext.jsx';

import { DialogIcon, DialogProgressTitle, DialogTitleContainer, DialogWarningIcon } from './styles';

const DeviceActionsDialog = ({
  backendIsRebooting,
  isRebootDialogOpen,
  isRebooting,
  isShutdownDialogOpen,
  isTestNotFailedAndNotReported,
  loadingReboot,
  loadingShutdown,
  onCloseReboot,
  onCloseShutdown,
  onReboot,
  onShutdown,
}) => {
  const { translate } = useTranslation();
  const rebootInProgress = loadingReboot || backendIsRebooting;
  const statusIcon = isTestNotFailedAndNotReported ? <DialogIcon /> : <DialogWarningIcon />;

  return (
    <>
      {isRebootDialogOpen || backendIsRebooting ? (
        <ConfirmationDialog
          isOpen={isRebootDialogOpen || backendIsRebooting}
          onClose={() => {
            if (!isRebooting && !backendIsRebooting) onCloseReboot();
          }}
          onConfirm={onReboot}
          title={
            rebootInProgress ? (
              <DialogTitleContainer>
                <DialogProgressTitle isReboot>
                  {translate('header.RebootInProgress')}
                </DialogProgressTitle>
              </DialogTitleContainer>
            ) : (
              translate('header.RebootDevice')
            )
          }
          subtitle={rebootInProgress ? '' : translate('header.AreYouSureReboot')}
          warningMessage={
            !isTestNotFailedAndNotReported &&
            !rebootInProgress &&
            translate('header.rebootWillBeEnabled')
          }
          confirmDisabled={!isTestNotFailedAndNotReported}
          icon={statusIcon}
          inProgress={rebootInProgress}
        />
      ) : null}

      <ConfirmationDialog
        isOpen={isShutdownDialogOpen}
        onClose={onCloseShutdown}
        onConfirm={onShutdown}
        title={
          loadingShutdown ? (
            <DialogTitleContainer>
              <DialogProgressTitle>{translate('header.SwitchOffInProgress')}</DialogProgressTitle>
            </DialogTitleContainer>
          ) : (
            translate('header.SwitchOffDevice')
          )
        }
        subtitle={loadingShutdown ? '' : translate('header.AreYouSureSwitchOff')}
        warningMessage={
          !isTestNotFailedAndNotReported &&
          !loadingShutdown &&
          translate('header.shutdownWillBeEnabled')
        }
        inProgress={loadingShutdown}
        confirmDisabled={!isTestNotFailedAndNotReported}
        icon={statusIcon}
      />
    </>
  );
};

export default DeviceActionsDialog;
